import styled from '@emotion/styled';
import tw from 'twin.macro';

export const StyledJumper = styled.span`
  ${tw`relative`}
  ${tw`h-[40px]`}
  ${tw`leading-[1]`}

  &:before {
    ${tw`content-['●●●']`}
    ${tw`text-[7px]`}
    ${tw`text-primary-p1`}
    ${tw`font-bold`}
    ${tw`tracking-[4px] leading-[39px]`}
  }
`;

export const StyledJumperContent = styled.span`
  ${tw`sr-only`}
`;
